import React, { useContext, useState } from "react";
import { CompanyContext } from "../context/CompanyContext";
import { Link, useNavigate } from "react-router-dom";
import { validateCompanyUser } from "./Validation";
import loginlogo from "../assets/images/loginlogo.png";
import Eye from "../assets/images/passeye.png";
import "../assets/styles/CompanyLogin.css";

import Productlogo from "../assets/images/Product-logo.svg";
import amhc_logo from "../assets/images/amhc_logo.png"; // amhc
import MGE from "../assets/images/recreatedsvg2.png"; //mge
import MXHealth from "../assets/images/MXHealth1.png"; // mx health (using same logo for now)
import GDC_logo from "../assets/images/GDCLogo.svg"; // gdc
import hayat_logo from "../assets/images/al-hayat-logo.png";
// hayat (using same logo for now)
// ........................................
const getBranchLogoForHost = () => {
  if (typeof window === "undefined") return GDC_logo;

  const host = window.location.hostname.toLowerCase();

  // American Hospital QA
  if (
    host === "mxhealth.americanhospital.qa" ||
    host === "amhctest.magunex.com"
  ) {
    return amhc_logo;
  }

  // MX Health
  if (
    host === "mxhealthdemo.magunex.com" ||
    host === "test.magunex.com" ||
    host === "mxqtest.magunex.com"
  ) {
    return MGE;
  }

  // GDC
  if (host === "gdcfmp.magunex.com" || host === "gdcfmptest.magunex.com") {
    return GDC_logo;
  }

  // Hayat App separate logo
  if (host === "hayapptest.magunex.com") {
    return hayat_logo;
  }

  // Default
  return MGE; // Default to American Hospital logo if no match
};
// ........................................

const CompanyLogin = () => {
  const { loginCompany, alert } = useContext(CompanyContext);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    coLicenseKey: "",
    cpPassword: "",
  }); //  Gdc_test_1

  // const [userData, setUserData] = useState({ coLicenseKey: 'vcpphgMYBrAOWFBbKjeBXcEoHi5vxfp7FZaFmP1WAVO7Z62fRK', cpPassword: 'Qmedpcl@25' });//  Gdc_test_1
  //  const [userData, setUserData] = useState({

  //   coLicenseKey: 'NndIlH9H3xwMqyQf3DYf2ZoWSspB0s1N6mNsjqVkdxFiMEEakH',
  //    cpPassword: 'Qulff@2025'
  // });
  const [errors, setErrors] = useState({});
  const branchLogo = getBranchLogoForHost();

  const handleLogin = (e) => {
    e.preventDefault();
    loginCompany(userData, validateCompanyUser, setErrors, navigate);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedUserData = { ...userData, [name]: value };
    setUserData(updatedUserData);
    setErrors(validateCompanyUser(updatedUserData));
  };

  return (
    <div style={styles.pageWrapper}>
      {/* Left Panel */}
      <div style={styles.leftPanel}>
        <div style={styles.overlay} className="animate-fade-in-up">
          <h2 style={styles.signInTitle}>Mx. Health</h2>
          <p style={styles.subText}>Sign in to your company</p>
          <img
            src={Productlogo}
            className="bl-productLogo"
            alt="recreatedSvg"
          />
        </div>
      </div>

      {/* Right Panel */}
      <div style={styles.rightPanel}>
        <div style={styles.loginBox}>
          <div className="bl-logoTop animate-slide-in-left">
            {/* className="bl-logoImg" */}
            <img src={branchLogo} alt="Branch Logo"  className="bl-logoImg" style={{width:"25%" ,height:"25%"}} /> 
          </div>
          <h2 style={styles.header} className="animate-slide-in-left">
            Company Login
          </h2>
          <p style={styles.welcome} className="animate-slide-in-left">
            Welcome back! Please sign in to your <br></br> Account
          </p>

          {alert.show && (
            <div
              style={{
                color: alert.type === "error" ? "red" : "green",
                marginBottom: "10px",
              }}
            >
              {alert.message}
            </div>
          )}

          <form onSubmit={handleLogin} style={styles.form}>
            {/* License Key */}
            <label style={styles.label} className="animate-slide-in-left">
              License Key
            </label>
            <input
              type="text"
              name="coLicenseKey"
              placeholder="Enter License Key"
              value={userData.coLicenseKey}
              onChange={handleChange}
              autoComplete="off"
              style={styles.input}
              className="animate-slide-in-left"
            />
            {errors.coLicenseKey && (
              <small style={styles.error}>{errors.coLicenseKey}</small>
            )}

            {/* Password with Eye Toggle */}
            {/* Password with Eye Toggle */}
            {/* Password with Custom Eye Toggle */}
            <label
              style={{ ...styles.label, marginBottom: "4px" }}
              className="animate-slide-in-left"
            >
              Password
            </label>
            <div
              style={{ position: "relative", marginBottom: "20px" }}
              className="animate-slide-in-left"
            >
              <input
                type={showPassword ? "text" : "password"}
                name="cpPassword"
                placeholder="Enter Password"
                value={userData.cpPassword}
                onChange={handleChange}
                autoComplete="off"
                style={{
                  ...styles.input,
                  paddingRight: "40px", // reserve space for eye image
                  marginTop: 0,
                  marginBottom: 0,
                }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={Eye}
                  alt={showPassword ? "Hide Password" : "Show Password"}
                  style={{
                    width: "20px",
                    height: "20px",
                    objectFit: "contain",
                  }}
                />
              </span>
            </div>

            <div style={styles.footerRow} className="animate-slide-in-left">
              <Link
                to="/auth/company-login/company-forgot-password"
                style={styles.forgotLink}
              >
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className="animate-slide-in-left gradient-button"
              style={{
                position: "relative",
                display: "inline-block",
                padding: "15px 40px",
                fontSize: "18px",
                fontWeight: "700",
                color: "#fff",
                textTransform: "uppercase",
                letterSpacing: "1px",
                border: "none",
                borderRadius: "2px",
                cursor: "pointer",
                background: "linear-gradient(45deg, #1A7F8E, #28a19a, #116466)",
                backgroundSize: "300% 300%",
                boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.1)";
                e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 15px rgba(0,0,0,0.3)";
              }}
            >
              Sign In
            </button>

            {/* Inline keyframes for gradient animation */}
            <style>
              {`
    @keyframes gradientAnimation {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `}
            </style>
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    margin: 0,
    padding: 0,
    fontFamily: "'Urbanist', sans-serif",
    overflow: "hidden",
  },
  leftPanel: {
    flex: 1,
    height: "100%",
    backgroundImage: `url(${loginlogo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  overlay: {
    padding: "60px 40px",
    maxWidth: "600px",
    color: "#fff",
  },
  signInTitle: {
    fontSize: "36px",
    fontWeight: 700,
    marginBottom: "15px",
  },
  subText: {
    fontSize: "24px",
    lineHeight: 1.5,
    fontWeight: 400,
  },
  rightPanel: {
    flex: 1,
    height: "100%",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    overflow: "hidden",
    paddingTop: "100px",
  },
  loginBox: {
    width: "80%",
    maxWidth: "650px",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    padding: "0px 40px", // ✅ padding inside login box
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  },
  header: {
    fontSize: "40px",
    fontWeight: "700",
    color: "#116466",
    marginBottom: "10px",
  },
  welcome: {
    fontSize: "20px",
    marginBottom: "30px",
    color: "#444",
    fontWeight: "400",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "18px",
    paddingBottom: "20px",
    paddingTop: "20px",
    fontWeight: "500",
    color: "#333",
    marginBottom: "10px",
  },
  input: {
    width: "100%",
    height: "50px",
    padding: "12px 15px",
    borderRadius: "6px",
    border: "2px solid #ccc",
    fontSize: "16px",
    boxSizing: "border-box",
    marginBottom: "10px",
    color: "lightgray",
  },
  error: {
    color: "red",
    fontSize: "12px",
    marginBottom: "10px",
  },
  forgotLink: {
    fontSize: "16px",
    textDecoration: "none",
    color: "#28a19a",
    fontWeight: "500",
  },
  footerRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "30px",
  },
};

export default CompanyLogin;
